import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import {Container, Row, Col, Input, Button, FormGroup, Label } from "reactstrap";

import { connect } from "react-redux";
import http from "../../../services/HttpService";
import Route from "../../../Routes";
import { AUTH_LOGOUT } from "../../../store/actions";

import Logo   from "../../../../assets/img/site/Logo.png";

@(connect((state: any) => {}) as any)
export default class Logout extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        loggedOut: false,
    };

    componentDidMount(): void {
        http.post("/users/logout")
            .then(() => {
                this.props.dispatch({
                    type: AUTH_LOGOUT,
                });

                this.setState({
                    loggedOut: true,
                });
            });
    }

    render() {
        if (this.state.loggedOut) {
            return <Redirect to={Route.toUrl("home")} />
        }

        return (
            <Container>
                <Row>
                    <Col md={{ size: 6, offset: 3 }} className="admin_login_block">
                        <div><img src={Logo} className="admin_login_logo"/><span>ADMINISTRATION</span></div>
                        <h2>Logging out ...</h2>
                    </Col>
                </Row>
            </Container>
        );
    }
}
